import People from './people/people';
import PeopleSingle from './people/people-single';
import FLSelect from './custom-types/fl-select';

const registerModules = (event, API) => {
	const modules = [People, PeopleSingle];
	API.registerModules(modules);
};

const registerCustomFields = (event, API) => {
	const customTypes = [FLSelect];
	API.registerModalFields(customTypes);
};

const bindEvents = () => {
	$(window).on('et_builder_api_ready', registerModules);
	if ($('.ENABLE_DIVI_NINJA_FORM_FIX').length > 0) {
		$(window).on('et_builder_api_ready', registerCustomFields);
	}
};

/**
 * @function init
 * @description Initializes modules.
 */

const init = () => {
	bindEvents();
};

export default init;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/modules.js